import React from 'react';
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import HelperUtils from '@shared/utils/HelperUtils';
import {ISelectedValue} from 'src/modules/appointment-schedular/sub-modules/ScheduleAppointmentSlot/ScheduleAppointmentSlot';
import SuccessIcon from '@components/system/MyIcons/SuccessIcon';

interface IScheduledAppointmentConfirmationProps {
  appointmentSlotSelectedValues: ISelectedValue;
}

const ScheduledAppointmentConfirmation = ({
  appointmentSlotSelectedValues
}: IScheduledAppointmentConfirmationProps): React.ReactElement => {
  const {t} = useTranslation();
  let formattedDate = '';
  if (appointmentSlotSelectedValues.appointmentDate) {
    formattedDate = moment(
      appointmentSlotSelectedValues.appointmentDate
    ).format('MMMM DD, YYYY');
  }
  let formattedTime = '';
  if (appointmentSlotSelectedValues.slot) {
    formattedTime = moment(
      appointmentSlotSelectedValues.slot.start_time,
      'hh:mm A'
    ).format('hh:mm A');
  }
  return (
    <div className="appointment-confirmation-wrapper">
      <div className="success-icon-container">
        <SuccessIcon width={128} height={128} />
      </div>
      <p className="appointment-scheduled-text">
        {t('APPOINTMENTS.SCHEDULE_APPOINTMENT.APPOINTMENT_SCHEDULED_TEXT', {
          patientName: HelperUtils.commaSeparatedFullName(
            appointmentSlotSelectedValues.patient?.first_name,
            appointmentSlotSelectedValues.patient?.last_name,
            appointmentSlotSelectedValues.patient?.middle_name
          ),
          date: formattedDate,
          time: formattedTime
        })}
      </p>
    </div>
  );
};

export default ScheduledAppointmentConfirmation;
